export default __webpack_public_path__ + "static/media/farmer3.e40effad.png";